import {secured as axios} from '../../../axios';

export class NewsFeed {
  static async getNewsFeed(offset, limit) {
    const res = await axios.get(
      `/user/actualities?offset=${offset}&limit=${limit}`,
    );
    return res?.data;
  }
}
